import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image";
import classNames from "classnames";
import * as React from "react";
import { ReactNode } from "react";
import { graphql } from "gatsby";

export const query = graphql`
  fragment TeaserImage on File {
    childImageSharp {
      gatsbyImageData(
        width: 512
        aspectRatio: 1
        quality: 70
        placeholder: BLURRED
        layout: CONSTRAINED
        transformOptions: { fit: COVER, cropFocus: ATTENTION }
      )
    }
  }
`;

export function CircleTeaser(props: {
  image: Omit<GatsbyImageProps, "className">;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className={"group"}>
      <figure className="relative rounded-full overflow-hidden aspect-square max-w-[32rem]">
        <GatsbyImage {...props.image} />
        <div
          className={classNames(
            "bg-primary py-4 px-8 text-white text-center",
            "flex flex-col group-hover:justify-center group-focus-within:justify-center gap-0",
            "absolute inset-0 aspect-square",
            "transition-all",
            "transform translate-y-2/3 group-hover:translate-y-0 group-focus-within:translate-y-0",
          )}
        >
          <h2 className={"text-xl md:text-2xl xl:text-3xl font-bold uppercase"}>
            {props.title}
          </h2>
          {props.children && (
            <p
              className={classNames(
                "transform origin-top scale-y-0",
                "transition-all opacity-0",
                "group-hover:scale-y-100 group-hover:opacity-100",
                "group-focus-within:scale-y-100 group-focus-within:opacity-100",
                "hidden xl:block",
              )}
            >
              {props.children}
            </p>
          )}
        </div>
      </figure>
    </div>
  );
}
